<template>
  <div class="jumbotron mb-0">
    <div class="container">
      <h1 class="display-3">Speakers Bureau User Manager</h1>
      <p class="lead">Manage users and their permissions.</p>
      <hr class="my-4" />
      <ul class="nav nav-pills">
        <li class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle"
            data-toggle="dropdown"
            href="#"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
            >Actions</a
          >
          <div class="dropdown-menu">
            <a class="dropdown-item" href="#" @click="createUser"
              >Create new User</a
            >
            <a class="dropdown-item" href="#" @click="generateNewAccounts"
              >Generate new Accounts</a
            >
          </div>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="#"
            @click="() => this.$router.push('/search')"
            >Search</a
          >
        </li>
        <li class="nav-item">
          <a class="nav-link disabled">Manage Users</a>
        </li>
        <li class="nav-item">
          <a class="nav-link text-danger" href="#" @click="logout">Logout</a>
        </li>
      </ul>
      <hr class="my-4" />
      <Filters :filters="filters" :onValueChanged="onFilterChanged" />
    </div>
  </div>
</template>

<script>
import { auth } from "firebase";
import Filters from "@/components/Users/Filters.vue";
import { User } from "../../typings/user";

export default {
  components: {
    Filters
  },
  props: {
    createUser: {
      type: Function,
      required: true,
      default: () => {}
    },
    logout: {
      type: Function,
      required: true,
      default: () => {}
    },
    filters: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    onFilterChanged: {
      type: Function,
      required: true,
      default: () => {}
    }
  },
  methods: {
    async generateNewAccounts() {
      try {
        this.$swal({
          title: "Generating new accounts...",
          type: "info",
          showConfirmButton: false,
          showCloseButton: false,
          allowEscapeKey: false
        });
        await User.generateNewUsersFromApplications();
        this.$swal({
          title: "Process started!",
          type: "success",
          text:
            "All applicants who do not already have an account will have one created for them."
        });
      } catch (err) {
        this.$swal({
          title: "Unable to generate new accounts!",
          type: "error"
        });
      }
    }
  }
};
</script>

<style></style>
